import { Browser } from "@kakaopay-common/user-agent";
var INTERFACE = /* @__PURE__ */ ((INTERFACE2) => {
  INTERFACE2["SET_TITLE"] = "set_title";
  INTERFACE2["HIDE_KEYBOARD"] = "hide_keyboard";
  INTERFACE2["CLOSE"] = "close";
  INTERFACE2["OPEN_URL"] = "open_url";
  INTERFACE2["OPEN_EXTERNAL_WEB"] = "open_external_web";
  INTERFACE2["OPEN_INTERNAL_WEB"] = "open_internal_web";
  INTERFACE2["REQUIREMENT"] = "requirement";
  INTERFACE2["SECURITIES_REQUIREMENT"] = "securities_requirement";
  INTERFACE2["AUTH_IDENTIFY"] = "auth_identify";
  INTERFACE2["AUTH_JOIN"] = "auth_join";
  INTERFACE2["LOCK_USER"] = "lock_user";
  INTERFACE2["TRANSFER_TERMS_NEED"] = "transfer_terms_need";
  INTERFACE2["UUID_CHANGED"] = "uuid_changed";
  INTERFACE2["KICKOUT"] = "kickout";
  INTERFACE2["NAVIGATION"] = "navigation";
  INTERFACE2["RETURN_CUSTOM_URL"] = "return_custom_url";
  INTERFACE2["ONLOAD"] = "onload";
  INTERFACE2["SHOW_LOADING"] = "show_loading";
  INTERFACE2["HIDE_LOADING"] = "hide_loading";
  INTERFACE2["SCROLL_BOUNCES"] = "scroll_bounces";
  INTERFACE2["IS_OS_LOCK"] = "is_os_lock";
  INTERFACE2["UUID"] = "uuid";
  INTERFACE2["PASSWORD"] = "password";
  INTERFACE2["HMAC"] = "hmac";
  INTERFACE2["CONNECT_ACCOUNT"] = "connect_account";
  INTERFACE2["SELECT_FRIEND"] = "select_friend";
  INTERFACE2["LOCATION"] = "location";
  INTERFACE2["CAPTURE"] = "capture";
  INTERFACE2["CUSTOM_CONFIRM"] = "custom_confirm";
  INTERFACE2["PDF_VIEWER"] = "pdf_viewer";
  INTERFACE2["CERT_SIGN"] = "cert_sign";
  INTERFACE2["CERT_SIGN_JOINT"] = "cert_sign_joint";
  INTERFACE2["CERT_REGISTER"] = "cert_register";
  INTERFACE2["CERT_REVIEW"] = "cert_review";
  INTERFACE2["DEREGISTER"] = "deregister";
  INTERFACE2["BACK"] = "back";
  INTERFACE2["CUSTOM_NAVIGATION_BACK"] = "custom_navigation_back";
  INTERFACE2["NAVIGATION_BAR_HIDDEN"] = "navigation_bar_hidden";
  INTERFACE2["SHARE"] = "share";
  INTERFACE2["ISSUE_PAY_CARD"] = "paycard_issue";
  INTERFACE2["REISSUE_PAY_CARD"] = "paycard_reissue";
  INTERFACE2["GET_APP_PUSH_PERMISSION"] = "get_app_push_permission";
  INTERFACE2["OPEN_APP_SETTINGS"] = "open_app_settings";
  INTERFACE2["APP_USER_ID"] = "app_user_id";
  INTERFACE2["OPEN_CAMERA"] = "open_camera";
  INTERFACE2["CLOSE_AND_OPEN"] = "close_and_open";
  INTERFACE2["GET_DEVICE_INFO"] = "get_device_info";
  INTERFACE2["SHOW_MISSION"] = "show_mission";
  INTERFACE2["COMPLETE_MISSION"] = "complete_mission";
  INTERFACE2["DISALLOW_PARENT_TOUCH_EVENT"] = "disallow_parent_touch_event";
  INTERFACE2["CUSTOM_NAVIGATION_CLOSE"] = "custom_navigation_close";
  INTERFACE2["DEREGISTER_SERVICE"] = "deregister_service";
  INTERFACE2["SET_COLOR_SCHEME"] = "set_color_scheme";
  INTERFACE2["GET_COLOR_SCHEME"] = "get_color_scheme";
  INTERFACE2["REQUEST_STORE_REVIEW"] = "request_store_review";
  INTERFACE2["SCRAP"] = "scrap";
  INTERFACE2["SCRAP_STATUS"] = "scrap_status";
  INTERFACE2["CHECK_PERMISSON"] = "check_permission";
  INTERFACE2["REQUEST_PERMISSON"] = "request_permission";
  INTERFACE2["CAN_GO_BACK"] = "can_go_back";
  INTERFACE2["KAKAOBANK_CONNECTION_COMPLETED"] = "kakaobank_connection_completed";
  INTERFACE2["REQUEST_PFM_DUTCH_PAY"] = "request_pfm_dutch_pay";
  INTERFACE2["GET_PAY_ACCESS_TOKEN"] = "get_pay_access_token";
  INTERFACE2["KICKOUT_ALL"] = "kickout_all";
  INTERFACE2["REQUEST_KAKAO_TERMS_AGREE_WEB"] = "request_kakao_terms_agree_web";
  INTERFACE2["REQUEST_KAKAO_AUTHORIZATION_CCODE"] = "request_kakao_authorization_code";
  INTERFACE2["PAYWEB_BOTTOM"] = "payweb_bottom";
  INTERFACE2["PAYWEB_BOTTOM_HEIGHT"] = "payweb_bottom_height";
  INTERFACE2["PAYWEB_TAB"] = "payweb_tab";
  INTERFACE2["OPEN_MEMBERSHIP_WALLET"] = "open_membership_wallet";
  INTERFACE2["OPEN_PAYCARD_OCR"] = "open_paycard_ocr";
  INTERFACE2["MEMBERSHIP_UPDATE_WIDGET"] = "membership_update_widget";
  INTERFACE2["TOKEN"] = "token";
  INTERFACE2["TRIGGER_MYDATA_UPDATE"] = "trigger_mydata_update";
  INTERFACE2["GET_MYDATA_UPDATE_STATUS"] = "get_mydata_update_status";
  INTERFACE2["UPDATE_MYDATA_CATEGORY_MEMO"] = "update_mydata_category_memo";
  INTERFACE2["SEND_MYDATA_CONNECTION_RESULT"] = "send_mydata_connection_result";
  INTERFACE2["SEND_MYDATA_ACCOUNT_CONNECTION_RESULT"] = "send_mydata_account_connection_result";
  INTERFACE2["CUSTOM_SNACKBAR"] = "custom_snackbar";
  INTERFACE2["CUSTOM_DIALOG"] = "custom_dialog";
  INTERFACE2["OPEN_PAYCARD_RRN_VALIDATE"] = "open_paycard_rrn_validate";
  INTERFACE2["OPEN_PAYCARD_DRIVER_LICENSE_VALIDATE"] = "open_paycard_driver_license_validate";
  INTERFACE2["OPEN_PAYCARD_RRN"] = "open_paycard_rrn";
  INTERFACE2["OPEN_PAYCARD_PASSWORD"] = "open_paycard_password";
  INTERFACE2["SET_BACKGROUND_SECURE"] = "set_background_secure";
  INTERFACE2["WILL_PUSH"] = "will_push";
  INTERFACE2["VIBRATE"] = "vibrate";
  INTERFACE2["PAYWEB"] = "payweb";
  INTERFACE2["COPY_TO_CLIPBOARD"] = "copy_to_clipboard";
  INTERFACE2["PASTE_FROM_CLIPBOARD"] = "paste_from_clipboard";
  INTERFACE2["OTP_CLOSE"] = "otp_close";
  INTERFACE2["OTP_CHANGE"] = "otp_change";
  INTERFACE2["SUBSCRIBE_SERVICE"] = "subscribe_service";
  INTERFACE2["PEDOMETER_WALK_COUNT"] = "pedometer_walk_count";
  INTERFACE2["SET_PEDOMETER_WALK_STATUS"] = "set_pedometer_walk_status";
  INTERFACE2["GET_PEDOMETER_WALK_STATUS"] = "get_pedometer_walk_status";
  INTERFACE2["SET_STATUSBAR_STYLE"] = "set_statusbar_style";
  INTERFACE2["GET_SYSTEM_STATUS_HEIGHT"] = "get_system_status_height";
  INTERFACE2["QRSCAN"] = "qrscan";
  INTERFACE2["GET_DEVICE_LOCATION"] = "get_device_location";
  INTERFACE2["SHOW_KEYBOARD"] = "show_keyboard";
  INTERFACE2["SHOW_NAVIGATION_ICON"] = "show_navigation_icon";
  INTERFACE2["ENABLE_PTR"] = "enable_ptr";
  INTERFACE2["END_PTR"] = "end_ptr";
  INTERFACE2["GET_USER_DEVICE_IDENTIFIER"] = "get_user_device_identifier";
  INTERFACE2["SHOW_SUBSIDIARY_SNACKBAR"] = "show_subsidiary_snackbar";
  INTERFACE2["GET_VISIBILITY_STATUS"] = "get_visibility_status";
  INTERFACE2["DFM_INSTALL"] = "dfm_install";
  INTERFACE2["TAB_FOCUS"] = "tab_focus";
  INTERFACE2["TAB_SWIPE"] = "tab_swipe";
  INTERFACE2["AUTH"] = "auth";
  INTERFACE2["QRSCAN_ABROAD_ATM"] = "qrscan_abroad_atm";
  INTERFACE2["ACTIVATE_LOCATION"] = "activate_location";
  INTERFACE2["SET_NAVIGATION_DIM"] = "set_navigation_dim";
  INTERFACE2["ACTIVATE_BLUETOOTH"] = "activate_bluetooth";
  INTERFACE2["IS_APP_LOCK"] = "is_app_lock";
  INTERFACE2["GET_SCREEN_READER_STATUS"] = "get_screen_reader_status";
  INTERFACE2["SET_STORAGE_ITEM"] = "set_storage_item";
  INTERFACE2["GET_STORAGE_ITEM"] = "get_storage_item";
  INTERFACE2["REMOVE_STORAGE_ITEM"] = "remove_storage_item";
  INTERFACE2["CLEAR_STORAGE"] = "clear_storage";
  INTERFACE2["CHECK_BLUETOOTH_ADVERTISING"] = "check_bluetooth_advertising";
  INTERFACE2["SET_BLUETOOTH_ADVERTISING"] = "set_bluetooth_advertising";
  INTERFACE2["SET_NAVIGATION_MODE"] = "set_navigation_mode";
  INTERFACE2["OPEN_NATIVE_FIT_TERMS"] = "open_native_fit_terms";
  INTERFACE2["GET_SELECTED_TAB_INDEX"] = "get_selected_tab_index";
  INTERFACE2["GET_CLIENT_USER_ID"] = "get_client_user_id";
  INTERFACE2["RECEIVE_PAY_MONEY"] = "receive_pay_money";
  INTERFACE2["SET_RECENTS_SCREENSHOT_ENABLED"] = "set_recents_screenshot_enabled";
  INTERFACE2["POLICY_AUTHENTICATION"] = "policy_authentication";
  INTERFACE2["POLICY_EXTERN_APP"] = "policy_extern_app";
  INTERFACE2["POLICY_IDENTIFY"] = "policy_identify";
  INTERFACE2["POLICY_KYC"] = "policy_kyc";
  INTERFACE2["POLICY_POSSESSION"] = "policy_possession";
  INTERFACE2["NEED_CLOSE"] = "need_close";
  INTERFACE2["SET_TAB_BADGE"] = "set_tab_badge";
  INTERFACE2["TRACK_AD_LOG"] = "track_ad_log";
  return INTERFACE2;
})(INTERFACE || {});
const NONE_INDENTIFIER = "none-identifier";
var COLOR_SCHEME = /* @__PURE__ */ ((COLOR_SCHEME2) => {
  COLOR_SCHEME2["DEFAULT"] = "default";
  COLOR_SCHEME2["LIGHT"] = "light";
  return COLOR_SCHEME2;
})(COLOR_SCHEME || {});
var BG_COLOR = /* @__PURE__ */ ((BG_COLOR2) => {
  BG_COLOR2["BG_WHITE"] = "bg_white";
  BG_COLOR2["BG_GREY"] = "bg_grey";
  BG_COLOR2["BG_LEGACY"] = "bg_legacy";
  return BG_COLOR2;
})(BG_COLOR || {});
var PERMISSION_TARGET = /* @__PURE__ */ ((PERMISSION_TARGET2) => {
  PERMISSION_TARGET2["CAMERA"] = "CAMERA";
  PERMISSION_TARGET2["PHOTO"] = "PHOTO";
  PERMISSION_TARGET2["LOCATION"] = "LOCATION";
  PERMISSION_TARGET2["BLUETOOTH"] = "BLUETOOTH";
  return PERMISSION_TARGET2;
})(PERMISSION_TARGET || {});
var ERROR_CODE = /* @__PURE__ */ ((ERROR_CODE2) => {
  ERROR_CODE2["NOT_SUPPORT_OS"] = "NOT_SUPPORT_OS";
  return ERROR_CODE2;
})(ERROR_CODE || {});
var VIEW_MODE = /* @__PURE__ */ ((VIEW_MODE2) => {
  VIEW_MODE2["MODAL"] = "modal";
  VIEW_MODE2["PUSH"] = "push";
  VIEW_MODE2["FADE_MODAL"] = "fade_modal";
  return VIEW_MODE2;
})(VIEW_MODE || {});
var WEBVIEW_TYPE = /* @__PURE__ */ ((WEBVIEW_TYPE2) => {
  WEBVIEW_TYPE2["PARENT"] = "parent";
  WEBVIEW_TYPE2["DEFAULT"] = "default";
  WEBVIEW_TYPE2["BOTTOM"] = "bottom";
  return WEBVIEW_TYPE2;
})(WEBVIEW_TYPE || {});
var URL_TYPE = /* @__PURE__ */ ((URL_TYPE2) => {
  URL_TYPE2["HTTP"] = "http";
  URL_TYPE2["SCHEME"] = "scheme";
  return URL_TYPE2;
})(URL_TYPE || {});
var NAVIGATION_TYPE = /* @__PURE__ */ ((NAVIGATION_TYPE2) => {
  NAVIGATION_TYPE2["DEFAULT"] = "default";
  NAVIGATION_TYPE2["TRANSPARENT"] = "transparent";
  NAVIGATION_TYPE2["HIDE"] = "hide";
  return NAVIGATION_TYPE2;
})(NAVIGATION_TYPE || {});
const securitiesTiaraDomain = Browser.isKakaoPayApp() ? "payapp.kakaopaysec.m.app" : "talk.kakaopaysec.m.app";
export {
  BG_COLOR,
  COLOR_SCHEME,
  ERROR_CODE,
  INTERFACE,
  NAVIGATION_TYPE,
  NONE_INDENTIFIER,
  PERMISSION_TARGET,
  URL_TYPE,
  VIEW_MODE,
  WEBVIEW_TYPE,
  securitiesTiaraDomain
};
